/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/ConnectorOverviewCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ConnectorOverviewCardTestIds = {
  cardConnectorOverview: "card-connector-overview",
  linkTargetSystem: "link-target-system"
} as const;
